var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38225 0.581726C4.82625 0.581726 4.375 1.03297 4.375 1.58898V2.05588C2.63796 2.50362 1.35325 4.07675 1.35325 5.95373V9.31123H9.41125V5.95373C9.41125 4.07675 8.12655 2.50362 6.3895 2.05588V1.58898C6.3895 1.03297 5.93826 0.581726 5.38225 0.581726ZM0.0102539 10.6542V11.9972H4.22024C4.102 12.2013 4.03958 12.4329 4.03925 12.6687C4.03925 13.0249 4.18075 13.3665 4.43261 13.6184C4.68447 13.8702 5.02607 14.0117 5.38225 14.0117C5.73844 14.0117 6.08004 13.8702 6.3319 13.6184C6.58376 13.3665 6.72525 13.0249 6.72525 12.6687C6.72453 12.4328 6.66165 12.2012 6.54295 11.9972H10.7543V10.6542H0.0102539Z",
    fill: "#25434F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotificationIcon);
export default __webpack_public_path__ + "static/media/mobileNotificationIcon.e0646f77ed9c910107066aeaaeb84e0f.svg";
export { ForwardRef as ReactComponent };